// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ox-1";
export var messageSideRight = "_ox-2";
export var subscribeToBackInStockBubbleContainer = "_ox-0";